import initialState from '../store/initialState'

export default function viewportReducer(state = initialState.viewport, action) {
  switch (action.type) {
    case "SET_COLLAPSE": {
      return {
        ...state,
        collapseSidebar: !state.collapseSidebar
      }
    }

    case "SHOW_MOBILE": {
      return {
        ...state,
        showMobileMenu: !state.showMobileMenu
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/viewportReducer.js